import { useMutation, useQueryClient } from 'react-query';

import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function Usepostspecificemployeesalary(cb) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.EMPLOYEE_PAYROLL_API,
        data
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('employee-payroll-data');
        queryClient.invalidateQueries('organisation_payroll');
        SuccessToast({ text: data.message });
        cb();
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
